

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../pages/home';
import PortfolioPage from '../pages/portfolio';
import LeadershipPage from '../pages/industry-leadership';
import OurTeam from '../pages/our-team'; 
import ContactPage from '../pages/contact-page';
import ArticleDetail from '../pages/article-details';
import Investment from '../pages/investment-thesis';
export default function AppRoutes() {
    return(
  
      <Routes>

        {/* Default English page */}
        <Route path="/" element={<HomePage lang="en" />} />

        {/* Other languages */}
        <Route path="/ja/" element={<HomePage lang="ja" />} />
<Route path='/portfolio' element={<PortfolioPage lang="en"/>} />
<Route path='/ja/portfolio' element={<PortfolioPage lang="ja"/>} />
<Route path='/leadership' element={<LeadershipPage lang="en"/>} />
<Route path='/ja/leadership' element={<LeadershipPage lang="ja"/>} />
<Route path='/our-team' element={<OurTeam lang="en" />} />
<Route path='/ja/our-team' element={<OurTeam lang="ja" />} />

<Route path='/contact' element={<ContactPage lang="en" />} />
<Route path='/ja/contact' element={<ContactPage lang="ja" />} />
<Route path="/articles/:slug" element={<ArticleDetail lang="en" />} />
<Route path="/ja/articles/:slug" element={<ArticleDetail lang="ja" />} />
<Route path="/investment" element={<Investment lang="en" />} />
<Route path="/ja/investment" element={<Investment lang="ja" />} />
        {/* Optional: catch-all redirect to English home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
}